import { combineReducers } from 'redux';
import { reducer as FormReducer } from 'redux-form';

import Login from 'components/app/login/reducer';
import Register from 'components/app/register/reducer';
import Dashboard from 'components/app/dashboard/reducer';
import ForgotPassword from 'components/app/forgot-password/reducer';
import ResetPassword from 'components/app/reset-password/reducer';
import AccountSetup from 'components/app/account-setup/reducer';
import UserAccount from 'components/app/user-account/reducer';
import Profile from 'components/app/profile/reducer';
import Asks from 'components/app/asks/reducer';
import Users from 'components/app/users/reducer';
import Partnerships from 'components/app/partnerships/reducer';
import BrowseNonprofits from 'components/app/browse/reducer';
import Nonprofit from 'components/app/nonprofits/reducer';
import Corporation from 'components/app/corporations/reducer';
import Settings from 'components/app/settings/reducer';

export default combineReducers({
  app: (state = [], action) => {
    return state;
  },
  login: Login,
  register: Register,
  dashboard: Dashboard,
  forgotPassword: ForgotPassword,
  resetPassword: ResetPassword,
  accountSetup: AccountSetup,
  userAccount: UserAccount,
  profile: Profile,
  asks: Asks,
  users: Users,
  partnerships: Partnerships,
  browse: BrowseNonprofits,
  nonprofits: Nonprofit,
  corporations: Corporation,
  settings: Settings,
  form: FormReducer
});



// WEBPACK FOOTER //
// ./src/reducer.js